module.exports = __webpack_public_path__ + "static/media/shiba_logo.554ab6e6.svg";